/**
 * Map the research tool's camelCase findings to the snake_case shape the Laravel
 * onboarding endpoints (and stored onboarding_data) use. Keeping a single shape
 * client-side means the review modal always reads/writes the same keys whether
 * the data came fresh from the stream or from the persisted record.
 */
export function findingsToData(findings = {}) {
  return {
    company_name: findings.companyName ?? "",
    company_summary: findings.companySummary ?? "",
    about_me: findings.aboutMe ?? "",
    communication_style: findings.communicationStyle ?? "",
    // The structured style bands seeded from that description — these are what
    // compose the base prompt server-side; the description is kept as a record.
    communication_style_bands: findings.communicationStyleBands ?? null,
    location: findings.location ?? "",
    // Scalar industry — populated by company-mode research; absent (→ "") on the
    // recruiter path, where industry data lives in recruiting_focus instead.
    industry: findings.industry ?? "",
    recruiting_focus: findings.recruitingFocus ?? null,
    user_base_prompt: findings.userBasePrompt ?? "",
    logo_url: findings.logoUrl ?? "",
    logo_source: findings.logoSource ?? "",
    // Every logo we verified, best first — the review step offers the ones the
    // user didn't get as one-click alternatives to the primary.
    logo_candidates: Array.isArray(findings.logoCandidates)
      ? findings.logoCandidates
          .filter((candidate) => candidate?.url)
          .map((candidate) => ({
            url: candidate.url,
            source: candidate.source ?? "",
          }))
      : [],
    logo_blurhash: findings.logoBlurhash ?? "",
    // Suggested theme colours from the brand's dominant palette, already
    // filtered for legibility on white by pickThemeColors. The full palette
    // rides along so the review step can offer the rest as swatches.
    primary_color: findings.primaryColor ?? "",
    secondary_color: findings.secondaryColor ?? "",
    brand_colors: Array.isArray(findings.brandColors)
      ? findings.brandColors.filter(
          (color) => typeof color === "string" && color !== ""
        )
      : [],
    // Citations can arrive as strings or objects (Perplexity) — normalise to
    // plain URL/title strings so the payload is a clean array of strings.
    sources: Array.isArray(findings.sources)
      ? findings.sources
          .map((source) =>
            typeof source === "string"
              ? source
              : (source?.url ?? source?.title ?? "")
          )
          .filter(Boolean)
      : [],
    confidence: findings.confidence ?? "",
    notes: findings.notes ?? "",
  };
}
